import type {
  AppointmentPlaceType,
  LpuDoctorMinPrices,
} from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/types'

function isNumber(value: unknown): value is number {
  return typeof value === 'number'
}

/**
 * Типы приёма с ценой: клиника, дом, телемед — как у DoctorPriceBlockByType.
 */
export default function getDoctorPlaceTypes(
  minPrices?: LpuDoctorMinPrices | null,
): AppointmentPlaceType[] {
  if (!minPrices) {
    return []
  }

  const types: AppointmentPlaceType[] = []

  if (isNumber(minPrices.tab_min_price) || isNumber(minPrices.tab_min_club_price)) {
    types.push('clinic')
  }

  if (isNumber(minPrices.tab_min_price_go)) {
    types.push('home')
  }

  if (
    isNumber(minPrices.tab_min_price_telemed)
    || isNumber(minPrices.tab_min_price_telemed_medtochka)
  ) {
    types.push('telemed')
  }

  return types
}
